import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { PayoutPaymentRequest, EngagementBankAccount, PaymentOrderState } from "@oysterhr/schema"

const PAYMENTS_STAFF_GET_PAYOUT_PAYMENT_METHOD = gql`
  query PaymentsStaffGetPayoutPaymentMethod($paymentRequestId: ID!) {
    payoutPaymentRequest(paymentRequestId: $paymentRequestId) {
      receiverId
      orders {
        state
        paymentMethod {
          ... on EngagementBankAccount {
            id
            state
            primary
            rawData
            currencyCode
          }
        }
      }
    }
  }
`

type Result = {
  receiverId?: string
  orders: Array<{
    state: PaymentOrderState
    paymentMethod: Pick<
      EngagementBankAccount,
      "id" | "state" | "primary" | "rawData" | "currencyCode" | "__typename"
    >
  }>
}

export const usePayoutPaymentMethod = ({
  paymentRequestId,
}: {
  paymentRequestId: PayoutPaymentRequest["id"]
}) => {
  return useQuery<{ payoutPaymentRequest: Result }>(PAYMENTS_STAFF_GET_PAYOUT_PAYMENT_METHOD, {
    variables: {
      paymentRequestId,
    },
  })
}
